// Bezeichnung mit Kurzform fürs Handy (z. B. „Team“ statt „Team & Zuweisung“). Es ist immer nur eine sichtbar
// (Umschalten in kanzlei-shell.css), damit Screenreader nur eine vorlesen.
export function Label({ text, short }: { text: string; short?: string }) {
  if (!short) return <>{text}</>;
  return (
    <>
      <span className="l-long">{text}</span>
      <span className="l-short">{short}</span>
    </>
  );
}
